import { render, staticRenderFns } from "./BreadcrumbPortal.vue?vue&type=template&id=1b4c5d08&scoped=true&"
import script from "./BreadcrumbPortal.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbPortal.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbPortal.vue?vue&type=style&index=0&id=1b4c5d08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4c5d08",
  null
  
)

export default component.exports